import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { IRecipeTag } from "../../sdk/types";
import { recipeTags } from "../../sdk/utils/api";

export interface IUseCreateRecipeTagParameters {
    name: string;
}

export const useCreateRecipeTag = (): UseMutationResult<
    IRecipeTag,
    unknown,
    IUseCreateRecipeTagParameters
> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IRecipeTag, unknown, IUseCreateRecipeTagParameters>({
        mutationFn: (parameters: IUseCreateRecipeTagParameters) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot create recipe tag without authorization token.",
                );
            }

            return recipeTags.RecipeTag.create({
                ...parameters,
                token: auth.token,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries("recipeTags");
        },
    });
};
